import { Card, Image, Loader, Modal, Paper, Stack, Text } from '@mantine/core';
import React, { useState } from 'react';
import Button from '../../../components/elements/Button';
// import DocViewer, { JPGRenderer,
// MSDocRenderer, PDFRenderer, PNGRenderer } from 'react-doc-viewer';
import PropTypes from 'prop-types';
import { getExtensionFromUrl } from '../../../utils/format';
import { DocumentViewer } from 'react-documents';
import { useFileDownloader } from '../../../utils/hooks';

const CardSupportingDocument = (
  {
    data = {}
  }
) => {
  const [opened, setOpened] = useState(false);
  const extension = getExtensionFromUrl(data?.documentSupport);

  const { downloadFile, isLoading } = useFileDownloader();
  // 1. Memoize the doc list so the reference doesn't change on every render
  // const docList = useMemo(() => {
  //   if (!data?.documentSupport) return [];
  //   return [
  //     {
  //       uri: data.documentSupport,
  //     }
  //   ];
  // }, [data?.documentSupport]);

  return (
    <Card bg="#F1F2F3" radius="md" ta="center">
      <Stack align="center">
        <Text fw={600}>Dokumen Pendukung</Text>
        <Paper mah={228} w={160} >
          {['jpg', 'jpeg', 'png'].includes(extension) ? <Image src={data?.documentSupport} width="100%" /> :
            <DocumentViewer
              className={'docsViewer'}
              style={{ width: '100%', height: '160px' }}
              url={data?.documentSupport}
              viewer="url"
            />}
          {/* <DocViewer
            config={{
              header: {
                disableFileName: true,
                disableHeader: true
              }
            }}
            documents={docList}
            pluginRenderers={[PDFRenderer, PNGRenderer, JPGRenderer, MSDocRenderer]}
          /> */}
        </Paper>
        {/* <img height={100} src={data?.url} width={100}/> */}
        <Button onClick={() => setOpened(true)} outlined>Buka Dokumen</Button>
      </Stack>
      <Modal centered onClose={() => setOpened(false)} opened={opened} size="xl" styles={{
        title: {
          fontWeight: 600,
          fontSize: 30
        }
      }} title="Dokumen Pendukung">
        <Stack>
          {['jpg', 'jpeg', 'png'].includes(extension) ? <Image height="100%" src={data?.documentSupport} width="100%" />
            : <DocumentViewer
              className={'docsViewer'}
              style={{ width: '100%', height: '25rem' }}
              url={data?.documentSupport}
              viewer="url"
            />}
          {/* <DocViewer config={{
            header: {
              disableFileName: true,
              disableHeader: true
            }
          }} documents={docList}
          pluginRenderers={[PDFRenderer, PNGRenderer, JPGRenderer, MSDocRenderer]}/> */}
          <Button disabled={isLoading} fullWidth onClick={() => downloadFile(data?.documentSupport, 'Dokumen Pendukung')} outlined>
            {isLoading ? <Loader/> : 'Unduh Dokumen Pendukung'}
          </Button>
          <Button fullWidth onClick={() => setOpened(false)}>Tutup</Button>
        </Stack>
      </Modal>
    </Card>
  );
};

export default CardSupportingDocument;

CardSupportingDocument.propTypes = {
  data: PropTypes.object
};
